import { CmsReactComponent } from 'components/cms/CmsReactComponent';
import { AuthenticationProps } from "./types";
import {
    PropertyDefinition,
} from "app/library/layout-builder";

export class AuthenticationDefinitions extends CmsReactComponent<AuthenticationProps> {
    static schemaName = "authentication";

    static propertyDefinitions: PropertyDefinition[] = [];
}


